<style lang="scss" scoped>
.admin-search {
  max-width: 300px !important;
  padding: 8px;
  margin-right: 5px;
}

.admin-tabs {
  border-radius: 4px;

  .v-tab:first-of-type {
    border-top-left-radius: 4px !important;
  }
}

.tab-active {
  background-color: rgba(25, 118, 210, 0.15);
}

.small-field {
  margin: 12px 12px 0px 0px !important;
  max-width: 285px !important;
  font-size: 80%;
  font-weight: 400;
}
</style>

<template>
  <div class="body-padding">
    <v-row>
      <v-spacer></v-spacer>
      <slot name="auxiliary-actions"></slot>
      <v-btn
        id="admin-controls-add-new-btn"
        small
        color="primary"
        class="mt-4 mr-6"
        @click="() => $emit('create')"
        v-if-has-permission:hide="addBtnPermission"
      >
        {{ addBtnText }}
      </v-btn>
    </v-row>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-select
        hide-details
        class="small-field white"
        dense
        outlined
        label="User role"
        id="user-role-select"
        :items="roles"
        item-value="user_role_id"
        item-text="title"
        v-model="selectedRole"
      />
    </v-row>
    <v-row>
      <v-col>
        <v-tabs v-model="selectedTab" class="mx-0 px-0 admin-tabs">
          <v-tab
            :id="`admin-controls-tab-${tab.text.toLowerCase()}`"
            v-for="tab in tabs"
            :key="tab.text"
            @click="updateRoute(tab)"
            active-class="tab-active"
          >
            {{ tab.text }}
          </v-tab>
          <v-spacer />
          <v-text-field
            id="admin-controls-search-input"
            v-model="search"
            flat
            outlined
            hide-details
            dense
            append-icon="mdi-magnify"
            label="Search..."
            class="admin-search"
          />
        </v-tabs>
        <div>
          <slot>
            <div style="border: 1px solid black; text-align: center">
              table should go in here
            </div>
          </slot>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
/* eslint camelcase: ["error", {allow: ["role"]}] */
import { DEFINE_SESSION_USER_ROLE } from '@/store/modules/user/actions';

export default {
  name: 'AdminBaseView',
  props: {
    addBtnText: String,
    addBtnPermission: String,
  },
  data: () => ({
    search: null,
    tabs: [
      { text: 'Users' },
      { text: 'Groups' },
      { text: 'Permissions' },
      { text: 'Roles' },
      { text: 'Role Levels' },
      { text: 'Domains' },
    ],
    selectedTab: 0,
    userRoles: [],
  }),
  computed: {
    type: vm => vm.$route.query.type,
    tabMap: vm => {
      const tmp = {};
      vm.tabs.forEach((tab, idx) => {
        tmp[tab.text.toLowerCase().replace(' ', '-')] = idx;
      });
      return tmp;
    },
    user: vm => vm.$store.getters.user,
    role: vm => vm.$store.getters.role,
    roles() {
      const stored_role = this.role ? [this.role] : [];
      const fetchedRoles = this.userRoles.length ? this.userRoles : stored_role;
      return fetchedRoles;
    },
    selectedRole: {
      get() {
        return this.role?.user_role_id;
      },
      set(id) {
        if (id && this.roles && (!this.role || id !== this.role.user_role_id)) {
          this.$store.dispatch(DEFINE_SESSION_USER_ROLE, { role: this.roles.find(r => r.user_role_id === id) });
        }
      },
    },
  },
  methods: {
    updateRoute(tab) {
      this.$router.push({ name: 'AdminBaseControlView', query: { type: tab.text.toLowerCase().replace(' ', '-') } });
    },
    setTab() {
      this.selectedTab = this.tabMap[this.type];
    },
    fetchRoles() {
      return this.$requests.get(`/v1/users/${this.user._id}/roles`).then(res => {
        const json = res.data;
        if (!json.length) {
          this.$toast.warning('No roles assigned to the current user...', { timeout: 3000 });
        } else {
          this.userRoles = json;
        }
        this.setRole();
      });
    },
    setRole() {
      if (this.role) {
        this.selectedRole = this.role.user_role_id;
      } else if (this.userRoles.length) {
        this.selectedRole = this.userRoles[0].user_role_id;
      }
    },
  },
  watch: {
    search(val) {
      this.$emit('search', val);
    },
    type() {
      this.setTab();
    },
  },
  mounted() {
    this.setTab();
    this.fetchRoles();
    this.setRole();
  },
};
</script>
